var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframeSrc && _vm.visible)?_c('iframe',{staticClass:"container__iframe",attrs:{"src":_vm.dataSrc,"align":"middle"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }